import { FC } from 'react'
import styles from 'components/features/pfm/LinkedAccountBalance/LinkedAccountBalanceNote.styl'

type LinkedAccountBalanceNoteProps = {

}
export const LinkedAccountBalanceNote: FC<LinkedAccountBalanceNoteProps> = (props) => {
  const { children } = props
  return (
    <div className={ styles.linkedAccountBalanceNote }>
      { children }
    </div>
  )
}
